class Nav {
    load(){
        this.loadToggle()

        console.log('nav module loaded.')
    }

    loadToggle(){
        let toggle = document.querySelector('.navbar-toggler');

        toggle.addEventListener('click', function(e) {
            e.preventDefault();
            toggle.classList.toggle('is-active');
        });
    }
}

export let nav = new Nav();